import React from "react";
import MainLayout from "../layout/main-layout";
import { MessageCircle, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();
  return (
    <MainLayout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-2xl text-center">
          <h1 className="text-7xl font-bold text-gray-800 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-2">
            Page Not Found
          </h2>
          <p className="text-gray-500 mb-6">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
            <button
              onClick={() => navigate("/")}
              className="bg-primary text-white px-5 py-2 rounded-md hover:bg-primary/90 transition"
            >
              Go to Homepage
            </button>
            <button
              onClick={() => navigate("/contact-us")}
              className="border border-primary text-primary px-5 py-2 rounded-md hover:bg-primary hover:text-white transition"
            >
              Contact Us
            </button>
          </div>
          <div className="text-sm text-gray-400">
            Or try exploring:
            <div className="flex flex-wrap justify-center gap-2 mt-2">
              <button
                onClick={() => navigate("/web-development-company")}
                className="px-3 py-1 bg-gray-100 hover:bg-primary hover:text-white rounded-full text-xs transition"
              >
                Web Development
              </button>
              <button
                onClick={() => navigate("/mobile-app-development-company")}
                className="px-3 py-1 bg-gray-100 hover:bg-primary hover:text-white rounded-full text-xs transition"
              >
                Mobile Apps
              </button>
              <button
                onClick={() => navigate("/ruby-on-rails-development-company")}
                className="px-3 py-1 bg-gray-100 hover:bg-primary hover:text-white rounded-full text-xs transition"
              >
                Ruby on Rails
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default NotFound;
